import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Input from '../../../common/simple/input';
import { oneLineSelectStyles } from '../../../common/shared/select.styled';

const AddOrEditContact = ({ 
    contactInfo, 
    onContactInfoChange, 
    onTypeDropdownChange, 
    selectedTenant, 
    edit,
    dropdownTypeOptions, 
    ltr
}) => {
    const { t } = useTranslation();

    return (
        <div className='contact-info'>
            <div >
                <div className='inner-title'>{t('reports.ownership_type')}</div>
                {/* TODO: add possibility to change ownership type while editing when backend is ready */}
                {edit ? <div className='value'>{t(`payments.${selectedTenant.tenant.tenantType}`)}</div> : (
                    <Select
                        styles={oneLineSelectStyles}
                        isRtl={!ltr}
                        placeholder={t('expenses.set_expenses.choose_type')}
                        options={dropdownTypeOptions}
                        value={contactInfo.tenantType}
                        onChange={onTypeDropdownChange}
                    />
                )}             
            </div>

            <div>
                <div className='inner-title'>{t('expenses.name')}</div>
                <Input 
                    value={contactInfo.name} 
                    onChange={e => onContactInfoChange(e, 'name')}
                />
            </div>

            <div>
                <div className='inner-title'>{t('expenses.phone_number')}</div>
                <Input 
                    value={contactInfo.phone} 
                    onChange={e => onContactInfoChange(e, 'phone')}
                />
            </div>

            <div>
                <div className='inner-title'>{t('expenses.email')}</div>
                <Input 
                    value={contactInfo.email} 
                    onChange={e => onContactInfoChange(e, 'email')}
                />
            </div>
        </div>
    )
}

export default AddOrEditContact;